import { render } from "./EmailTemplates.vue?vue&type=template&id=21120026&scoped=true&lang=pug"
import script from "./EmailTemplates.vue?vue&type=script&lang=js"
export * from "./EmailTemplates.vue?vue&type=script&lang=js"

import "./EmailTemplates.vue?vue&type=style&index=0&id=21120026&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21120026"]])

export default __exports__